import { Server, Users, Ghost, Building2, TrendingUp, AlertTriangle, X, HardDrive, Settings, Gift, Sparkles } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../../services/api'
import { useState,useEffect } from "react"

export default function SuperAdminDashboard() {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const[ghostModal, setGhostModal] = useState(null)
    const [ghostReason, setGhostReason] = useState('')
    
    // Modale de gestion
    const [manageModal, setManageModal] = useState(null)
    const [newQuota, setNewQuota] = useState('')

    const loadData = () => {
        api.get('/api/superadmin/dashboard')
            .then(res => setData(res.data))
            .catch(err => toast.error("Accès refusé"))
            .finally(() => setLoading(false))
    }

    useEffect(() => { loadData() },[])

    const handleUpdateQuota = async () => {
        try {
            await api.patch(`/api/superadmin/workspaces/${manageModal.id}/quota`, { quota_mb: parseInt(newQuota) })
            toast.success("Quota mis à jour")
            setManageModal(null)
            loadData()
        } catch(e) { toast.error("Erreur") }
    }

    const handleExtendTrial = async () => {
        if(!confirm("Offrir +7 jours d'essai à ce client ?")) return
        try {
            await api.post(`/api/superadmin/workspaces/${manageModal.id}/extend-trial`)
            toast.success("Essai prolongé de 7 jours !")
            setManageModal(null)
            loadData()
        } catch(e) { toast.error("Erreur") }
    }

    const handleToggleAI = async () => {
        try {
            await api.post(`/api/superadmin/workspaces/${manageModal.id}/toggle-ai`)
            toast.success("Droits IA mis à jour !")
            setManageModal(null)
            loadData()
        } catch(e) { toast.error("Erreur") }
    }

    //useEffect(() => { loadData()},[])

    const confirmGhostLogin = async () => {
        if (!ghostReason.trim()) return toast.error("Le motif est obligatoire pour la traçabilité HDS.");

        try {
            toast.loading("Connexion au mode fantôme...")
            const res = await api.post(`/api/superadmin/ghost-login/${ghostModal.id}`, { reason: ghostReason })
            
            const currentToken = localStorage.getItem('token')
            localStorage.setItem('super_admin_token', currentToken)
            localStorage.setItem('token', res.data.access_token)
            
            toast.success(`Connecté en tant que ${res.data.target_name}`)
            window.location.href = '/admin'
        } catch (e) {
            // Le e.message affichera la vraie erreur au lieu de crasher
            toast.error("Erreur de connexion fantôme : " + e.message)
        }
    }


    const handleGhostLogin = (workspace) => {
        setGhostModal(workspace)
        setGhostReason('')
    }

    if (loading) return <div className="flex justify-center p-20"><div className="spinner border-indigo-600"/></div>


    return (
        <div className="space-y-6 animate-in fade-in pb-10">
            <div>
                <h1 className="text-2xl font-serif text-indigo-900 flex items-center gap-2">
                    <Server className="w-6 h-6" /> Administration SaaS
                </h1>
                <p className="text-gray-500 mt-1">Supervisez l'infrastructure BellaBlue.</p>
            </div>

            {/* KPI */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center justify-between">
                    <div>
                        <p className="text-sm font-bold text-gray-500 uppercase">Cabinets Actifs</p>
                        <p className="text-3xl font-black text-gray-800 mt-1">{data?.stats.total_workspaces || 0}</p>
                    </div>
                    <div className="p-3 bg-indigo-50 rounded-xl text-indigo-600"><Building2 className="w-6 h-6"/></div>
                </div>
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center justify-between">
                    <div>
                        <p className="text-sm font-bold text-gray-500 uppercase">Patients Hébergés</p>
                        <p className="text-3xl font-black text-gray-800 mt-1">{data?.stats.total_patients || 0}</p>
                    </div>
                    <div className="p-3 bg-sage-50 rounded-xl text-sage-600"><Users className="w-6 h-6"/></div>
                </div>
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm flex items-center justify-between">
                    <div>
                        <p className="text-sm font-bold text-gray-500 uppercase">Abonnements SaaS</p>
                        <p className="text-3xl font-black text-gray-800 mt-1">{data?.stats.active_subscriptions || 0}</p>
                    </div>
                    <div className="p-3 bg-green-50 rounded-xl text-green-600"><TrendingUp className="w-6 h-6"/></div>
                </div>
            </div>
            
            {/* LIGNE 2 KPI */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm">
                    <p className="text-sm font-bold text-gray-500 uppercase mb-1">Revenu 30 Jours (MRR)</p>
                    <p className="text-3xl font-black text-blue-600">{data?.stats.mrr?.toFixed(2)} €</p>
                </div>
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm">
                    <p className="text-sm font-bold text-gray-500 uppercase mb-1">Total Encaissé (SaaS)</p>
                    <p className="text-3xl font-black text-gray-800">{data?.stats.total_revenue?.toFixed(2)} €</p>
                </div>
                <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm">
                    <p className="text-sm font-bold text-gray-500 uppercase mb-1 flex items-center gap-2"><HardDrive className="w-4 h-4"/> Espace Disque Serveur</p>
                    <p className="text-3xl font-black text-gray-800">{data?.stats.server_disk_usage} <span className="text-lg text-gray-500 font-medium">/ {data?.stats.server_disk_total} Go</span></p>
                </div>
            </div>

            {/* LISTE DES TENANTS */}
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                <div className="p-5 border-b border-gray-100 bg-gray-50">
                    <h2 className="font-bold text-gray-700">Locataires (Workspaces)</h2>
                </div>
                <table className="w-full text-sm text-left">
                    <thead className="text-xs text-gray-400 uppercase bg-white border-b border-gray-100">
                        <tr>
                            <th className="px-5 py-3">ID</th>
                            <th className="px-5 py-3">Cabinet & Admin</th>
                            <th className="px-5 py-3 text-center">Patients</th>
                            <th className="px-5 py-3 text-center">Stockage</th>
                            <th className="px-5 py-3 text-center">LTV (CA)</th>
                            <th className="px-5 py-3 text-center">Statut</th>
                            <th className="px-5 py-3 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {data?.workspaces?.map(ws => (
                            <tr key={ws.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-5 py-4 font-mono text-gray-400">#{ws.id}</td>
                                <td className="px-5 py-4">
                                    <p className="font-bold text-gray-800">{ws.name}</p>
                                    <p className="text-xs text-gray-500">{ws.owner_email}</p>
                                    <p className="text-[10px] font-mono text-indigo-500 mt-1">{ws.slug}.bellablue.contact</p>
                                </td>
                                <td className="px-5 py-4 text-center font-bold text-gray-600">{ws.patient_count}</td>
                                <td className="px-5 py-4 text-center">
                                    <div className="flex flex-col items-center">
                                        <span className="text-xs font-bold text-gray-700">{ws.usage_mb} / {ws.quota_mb} Mo</span>
                                        <div className="w-20 bg-gray-200 rounded-full h-1.5 mt-1 overflow-hidden shadow-inner">
                                            <div
                                                className={`h-1.5 rounded-full ${ws.usage_mb / ws.quota_mb > 0.9 ? 'bg-red-500' : 'bg-sage-500'}`}
                                                style={{ width: `${Math.min((ws.usage_mb / ws.quota_mb) * 100, 100)}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-5 py-4 text-center font-bold text-blue-600">{ws.ltv.toFixed(2)} €</td>
                                <td className="px-5 py-4 text-center">
                                    <div className="flex flex-col gap-1 items-center">
                                        <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded ${ws.status === 'active' ? 'bg-green-100 text-green-700' : ws.status === 'trialing' ? 'bg-blue-100 text-blue-700' : 'bg-red-100 text-red-700'}`}>
                                            {ws.status}
                                        </span>
                                        {ws.ai_enabled && <span className="text-[9px] bg-purple-100 text-purple-700 px-1.5 rounded-full font-bold">✨ IA ON</span>}
                                    </div>
                                </td>

                                <td className="px-5 py-4 text-right">
                                    <div className="flex justify-end gap-2">
                                        {/* LIEN DIRECT VERS LE DASHBOARD STRIPE DU CLIENT */}
                                        {ws.stripe_customer_id && (
                                            <a 
                                                href={`https://dashboard.stripe.com/customers/${ws.stripe_customer_id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="p-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded transition-colors flex items-center justify-center"
                                                title="Ouvrir la fiche client dans Stripe (Factures, Remises)"
                                            >
                                                <TrendingUp className="w-4 h-4" />
                                            </a>
                                        )}
                                        <button 
                                            onClick={() => { setManageModal(ws); setNewQuota(ws.quota_mb.toString()) }}
                                            className="p-1.5 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded transition-colors"
                                            title="Gérer (Quota, Essai)"
                                        >
                                            <Settings className="w-4 h-4" />
                                        </button>
                                        <button 
                                            onClick={() => handleGhostLogin(ws)}

                                            className="btn bg-gray-800 hover:bg-black text-white py-1.5 px-3 text-xs flex items-center justify-center gap-1.5 shadow-md transition-all hover:scale-105"
                                            title="Se connecter en tant que ce cabinet"
                                        >
                                            <Ghost className="w-3.5 h-3.5" /> Support
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modale de justification HDS */}
            {ghostModal && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                                <Ghost className="w-5 h-5 text-indigo-600"/> Mode Fantôme
                            </h3>
                            <button onClick={() => setGhostModal(null)}><X className="w-5 h-5 text-gray-400 hover:text-gray-600"/></button>
                        </div>
                        <div className="bg-red-50 border border-red-200 rounded-xl p-3 mb-4 text-sm text-red-800">
                            <strong>Avertissement HDS :</strong> Vous allez accéder aux données médicales du cabinet <strong>{ghostModal.name}</strong>. Cet accès sera journalisé.
                        </div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Motif de l'intervention (Obligatoire)</label>
                        <textarea
                            rows={3}
                            value={ghostReason}
                            onChange={(e) => setGhostReason(e.target.value)}
                            placeholder="Ex: Demande de support par email le 05/05 (Ticket #123)..."
                            className="w-full bg-gray-50 border-gray-200 rounded-xl p-3 mb-4 focus:ring-indigo-500"
                            autoFocus
                        />
                        <button 
                            onClick={confirmGhostLogin}
                            disabled={!ghostReason.trim()}
                            className="w-full btn bg-indigo-600 hover:bg-indigo-700 text-white disabled:opacity-50"
                        >
                            Confirmer la connexion
                        </button>
                    </div>
                </div>
            )}
            {/* Modale de Gestion (SuperAdmin) */}
            {manageModal && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                                <Settings className="w-5 h-5 text-gray-500"/> Gestion Cabinet
                            </h3>
                            <button onClick={() => setManageModal(null)}><X className="w-5 h-5 text-gray-400 hover:text-gray-600"/></button>
                        </div>

                        <div className="space-y-6">
                            {/* Modification Quota */}
                            <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                                <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Quota Espace Disque (Mo)</label>
                                <div className="flex gap-2">
                                    <input 
                                        type="number" 
                                        value={newQuota} 
                                        onChange={e => setNewQuota(e.target.value)}
                                        className="flex-1 text-sm border-gray-200 rounded-lg py-2 focus:ring-sage-500"
                                    />
                                    <button onClick={handleUpdateQuota} className="btn btn-primary px-4 py-2 text-sm shadow-sm">Valider</button>
                                </div>
                                <p className="text-[10px] text-gray-400 mt-2">1 Go = 1024 Mo. Le changement est immédiat.</p>
                            </div>

                            {/* Actions Commerciales */}
                            <div>
                                <h4 className="text-xs font-bold text-gray-500 uppercase mb-2">Actions commerciales</h4>
                                {manageModal.status !== 'active' ? (
                                    <>
                                        <button 
                                            onClick={handleExtendTrial}
                                            className="w-full btn bg-orange-100 hover:bg-orange-200 text-orange-700 flex justify-center items-center gap-2 py-3 transition-colors border border-orange-200 shadow-sm"
                                        >
                                            <Gift className="w-4 h-4"/> Offrir +7 Jours d'essai
                                        </button>
                                        <p className="text-[10px] text-center text-gray-400 mt-2">Rajeunit le compte et débloque l'accès s'il était suspendu.</p>
                                    </>
                                ) : (
                                    <div className="bg-gray-50 border border-gray-200 p-4 rounded-xl text-center">
                                        <p className="text-sm font-bold text-gray-600 mb-1">Abonnement Actif</p>
                                        <p className="text-[10px] text-gray-500 leading-tight">Pour offrir un mois gratuit ou une remise, appliquez un Coupon directement depuis la fiche de ce client sur votre tableau de bord Stripe.</p>
                                    </div>
                                )}
                                <button 
                                    onClick={handleToggleAI}
                                    className={`w-full mt-4 btn flex justify-center items-center gap-2 py-3 transition-colors border shadow-sm ${manageModal.ai_enabled ? 'bg-purple-100 border-purple-200 text-purple-700 hover:bg-purple-200' : 'bg-white border-gray-200 text-gray-500 hover:bg-gray-50'}`}
                                >
                                    <Sparkles className="w-4 h-4"/> 
                                    {manageModal.ai_enabled ? "Désactiver l'accès à Gaston (IA)" : "Activer l'accès à Gaston (IA)"}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}